<!-- Main container -->
@if (terminalBatchCtx$ | async; as ctx) {
  <div class="layout-col full">
    <elder-table
      class="flex"
      matSort
      [data]="data"
      [selectionVisible]="true"
      [selectionMultiEnabled]="true"
      [selectableEvaluatorFn]="deletionSelectionFn(ctx)"
      (itemClick)="openDetail($event)"
      (selectionChange)="selectedPackages = $event"
    >
      <elder-data-toolbar
        *elderTableToolbar
        [canMore]="true"
        [canAdd]="false"
        [canRemove]="canRemove(ctx)"
        (requestRemove)="onRequestRemove($event)"
      >
        <ng-template elderToolbarContent="left.actions">
          <div class="layout-row gap-md pt-md">
            <button
              mat-icon-button
              color="primary"
              [disabled]="!canAdd(ctx)"
              [matBadge]="'!'"
              [matBadgeHidden]="!canAdd(ctx) || hasPackages()"
              [matBadgeColor]="'warn'"
              (click)="onRequestNew($event)"
            >
              <mat-icon>add</mat-icon>
            </button>
            <app-print-button
              appPrintCommand
              color="primary"
              [disabled]="!canPrintPackageLabels(ctx)"
              [reportSpec]="labelReport$ | async"
              [printerId]="ctx.terminal.labelPrinter?.printerId"
            >
            </app-print-button>
          </div>
        </ng-template>
        <ng-template elderToolbarContent="right.actions">
          @if (storageOverview$ | async; as overview) {
            <div class="layout-row place-start-center gap-md py-md pr-xl">
              <button
                mat-flat-button
                color="primary"
                [disabled]="!isManualCheckInNecessary() || !hasPackages()"
                [matBadge]="'!'"
                [matBadgeHidden]="!isManualCheckInNecessary() || !hasPackages()"
                [matBadgeColor]="'warn'"
                (click)="onManualCheckIn()"
              >
                {{ 'actions.assign' | translate }}
              </button>
              <mat-form-field floatLabel="always" elderFormFieldLabel>
                <mat-label>{{ 'shopfloor.storage.currentLocation' | translate }}</mat-label>
                <input
                  matInput
                  name="exactStorageLocation"
                  readonly
                  placeholder="-"
                  [ngModel]="overview.currentPackageLocation"
                />
              </mat-form-field>
              <mat-form-field floatLabel="always" elderFormFieldLabel>
                <mat-label>{{ 'shopfloor.storage.setupStationWeight' | translate }}</mat-label>
                <elder-quantity-input
                  name="expectedPackageWeight"
                  readonly
                  [ngModel]="overview.expectedPackageWeight"
                >
                </elder-quantity-input>
                <mat-error elderValidationError></mat-error>
              </mat-form-field>
            </div>
          }
        </ng-template>
        <button
          mat-menu-item
          [disabled]="!canPreviewPackageLabels(ctx)"
          (click)="onPreviewPackageLabels(ctx)"
        >
          <mat-icon>preview</mat-icon>
          <span>{{ 'labels.preview' | translate }}</span>
        </button>
      </elder-data-toolbar>
      <!-- number Column -->
      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
          {{ 'context.number' | translate }}
        </th>
        <td mat-cell *matCellDef="let pkg">{{ pkg.number }}</td>
      </ng-container>
      <!-- type Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
          {{ 'context.type' | translate }}
        </th>
        <td mat-cell *matCellDef="let pkg">{{ pkg.type ? pkg.type.name : pkg.typeId }}</td>
      </ng-container>
      <!-- weight Column -->
      <ng-container matColumnDef="weight">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" elderNumberCell>
          {{ 'context.weight' | translate }}
        </th>
        <td mat-cell *matCellDef="let pkg" elderNumberCell>
          @if (hasWeight(pkg)) {
            <span>{{ pkg.weight | elderQuantity }}</span>
          }
        </td>
      </ng-container>
      <!-- hints Column -->
      <ng-container matColumnDef="hints">
        <th mat-header-cell *matHeaderCellDef>{{ 'context.hints' | translate }}</th>
        <td mat-cell *matCellDef="let pkg">
          <div class="layout-row place-start-center">
            @if (pkg.containsPartialItems) {
              <mat-icon [matTooltip]="'packages.partialItems' | translate"> announcement </mat-icon>
            }
          </div>
        </td>
      </ng-container>
      @if (isPackageSharingEnabled() && isWorkOrderRoutePackageSharingEnabled(ctx)) {
        <ng-container matColumnDef="shared">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'packaging.batchPackageSharing.shared' | translate }}
          </th>
          <td mat-cell *matCellDef="let pkg">
            <div class="layout-row place-start-center">
              @if (isUsedShared(pkg, ctx)) {
                <mat-icon> call_split </mat-icon>
              }
            </div>
          </td>
        </ng-container>
      }
    </elder-table>
  </div>
}
